export class SubscriberProductAgreementModel {
          id?: string
          dateAccept: Date|string|null = null
          idUser: string = ''
          emailUser: string = ''
          nameUser: string = ''
          link: string = ''

    constructor(s?:Partial<SubscriberProductAgreementModel>) {
        Object.assign(this, s)   
    }

    hasAccepted():boolean {
        return !!this.dateAccept
    }

    getUserInfo():string {
        if (!this.hasAccepted()) {
            return ''
        }

        return `${this.nameUser} (${this.emailUser})`
    }
}
